import React, {useState, useEffect} from "react";
import ProfilesList from "./ProfilesList";
import ProfileEditor from "./ProfileEditor";
import Notification from "../Common/Notification";

const ProfilesSettings = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedAll, setSelectedAll] = useState(false);
    const [showEditor, setShowEditor] = useState(false);
    const [currentProfile, setCurrentProfile] = useState(null);
    const [notification, setNotification] = useState({
        show: false,
        type: 'success',
        message: '',
    });


    // Debounce search term
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchTerm]);

    // Function to show a notification
    const showNotification = (type, message) => {
        setNotification({
            show: true,
            type,
            message,
        });

        // Auto hide after 5 seconds for success notifications
        if (type === 'success') {
            setTimeout(() => {
                setNotification(prev => ({...prev, show: false}));
            }, 5000);
        }
    };

    // Function to hide notification
    const hideNotification = () => {
        setNotification(prev => ({...prev, show: false}));
    };

    // Handle create new profile
    const handleCreateProfile = () => {
        setCurrentProfile(null);
        setShowEditor(true);
    };

    // Handle edit profile
    const handleEditProfile = (profile) => {
        setCurrentProfile(profile);
        setShowEditor(true);
    };

    // Handle back from editor
    const handleCloseEditor = () => {
        setShowEditor(false);
        setCurrentProfile(null);
    };

    return (
        <div>
            <ProfilesList
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                debouncedSearchTerm={debouncedSearchTerm}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedAll={selectedAll}
                setSelectedAll={setSelectedAll}
                showNotification={showNotification}
                onCreateProfile={handleCreateProfile}
                onEditProfile={handleEditProfile}
            />

            {showEditor && (
                <ProfileEditor
                    profile={currentProfile}
                    onClose={handleCloseEditor}
                    showNotification={showNotification}
                />
            )}

            {/* Notification */}
            {notification.show && (
                <Notification
                    type={notification.type}
                    message={notification.message}
                    onClose={hideNotification}
                />
            )}
        </div>
    );
};

export default ProfilesSettings;
